import React from 'react';
import { Modal } from 'react-bootstrap';
import { CustomButton } from '../../_common/CustomButton/CustomButton';
import './ErrorModal.scss';

interface ModalProps {
    show: boolean;
    onCancel: () => void;
}

const ErrorModal = ({ show, onCancel }: ModalProps): React.ReactElement => {
    return (
        <Modal show={show} onHide={() => {}} centered className="ErrorModal-Container">
            <Modal.Header className="ErrorModal-Header">
                <i className="material-icons DeleteModal-CloseIcon" onClick={onCancel}>
                    clear
                </i>
            </Modal.Header>
            <Modal.Body>
                <div className="ErrorModal-HeaderText">Error occurred!</div>
                <div className="ErrorModal-BodyText">Job has active loads. Cannot be deleted!</div>
            </Modal.Body>
            <Modal.Footer className="ErrorModal-Footer">
                <div className="ErrorModal-ButtonContainer">
                    <CustomButton title="OK" onClick={onCancel} isBordered={false} />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ErrorModal;

